module.exports = __webpack_public_path__ + "img/story3.30cdad8d.jpeg";